<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;
  }
</style>
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a routerLink="/corporate//marketing-tool">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">Journey List</li>
    </ol>
  </nav>
</div>
<div class="container mt-2 themeTblReso position-relative z-in99">
  <div class="d-flex mb-2 align-items-center flex-wrap" style="gap: 10px">
    <div class="flex-grow-1">
      <select
        class="form-control formstyle"
        [(ngModel)]="companyID"
        (change)="onCompanyChange($event)"
      >
        <option value="0" disabled>Select Company Name</option>
        <option
          *ngFor="let userObj of getJourneyObj"
          value="{{ userObj.customer_id }}"
        >
          {{ userObj.customer_company_name }}
        </option>
      </select>
    </div>
    <div class="flex-grow-1">
      <select
        [disabled]="!domainData || domainData.length === 0"
        class="form-control formstyle"
        [(ngModel)]="domainID"
        (change)="onDomainChange($event)"
      >
        <option value="0">Select Domain</option>
        <option *ngFor="let domainObj of domainData" [value]="domainObj.id">
          {{ domainObj.domain_name }}
        </option>
        <option *ngIf="!domainData || domainData.length === 0" disabled>
          No domains available
        </option>
      </select>
    </div>

    <div class="flex-grow-1">
      <select
        [disabled]="!journeyData || journeyData.length === 0"
        class="form-control formstyle"
        [(ngModel)]="journeyID"
        (change)="onJourneyChange($event)"
      >
        <option value="0">Select Journey</option>
        <option *ngFor="let j of journeyData" [value]="j.journey_id">
          {{ j.journey_name }}
        </option>
        <option *ngIf="!journeyData || journeyData.length === 0" disabled>
          No journeys available
        </option>
      </select>
    </div>

    <div class="flex-grow-0 d-flex align-items-center" style="gap: 10px">
      <input
        [disabled]="!companyID"
        type="button"
        value="Add New"
        class="custbtn m-0"
        routerLink="/corporate/create-journey"
      />
      <button
        type="button"
        class="btn custbtn-outline m-0"
        (click)="clearFilter()"
      >
        Clear Filter
      </button>
    </div>
  </div>
  <div class="row1 mt-1">
    <div id="no-more-tables">
      <table class="cf bdrStCustom accordSmall" style="width: 100%">
        <thead class="cf">
          <tr>
            <th>Journey Name</th>
            <th>Created On</th>
            <th style="text-align: center">Active</th>
            <th style="text-align: start">Action</th>
          </tr>
        </thead>
        <tbody *ngFor="let obj of JourneyObj">
          <tr id="{{ obj.id }}" class="multi-collapse">
            <td data-title="Journey Name">{{ obj.cjb_name }}</td>
            <td data-title="Created On">{{ obj.createdon | date }}</td>
            <td data-title="Status" class="text-center">
              <button
                type="button"
                [class.active]="obj.isactive"
                [class.inactive]="!obj.isactive"
                class="btn btn-sm active-toggle p-0"
                (click)="updateJourneyStatus(obj, btnRef, iconRefOn)"
              >
                <i
                  [class]="obj.isactive ? 'bi-toggle2-on' : 'bi-toggle2-off'"
                  class="bi"
                ></i>
              </button>
            </td>
            <td data-title="Action">
              <div class="d-flex align-items-center action-btns">
                <button
                  class="btn action-btn edit"
                  type="button"
                  ngbTooltip="Edit"
                  placement="top"
                >
                  <i
                    class="fa fa-edit mr-2 linkForce"
                    (click)="editJourneyRecord(obj.id)"
                  ></i>
                </button>
                <button
                  class="btn action-btn delete"
                  type="button"
                  ngbTooltip="Delete"
                  placement="top"
                >
                  <i
                    class="fa fa-trash mr-2 linkForce"
                    (click)="deleteJourneyRecord(obj.id)"
                  ></i>
                </button>
                <button
                  class="btn action-btn copy"
                  type="button"
                  ngbTooltip="Copy"
                  placement="top"
                >
                  <i
                    class="fa fa-copy linkForce"
                    (click)="cloneJourneyTemplate(obj.id, obj.cjb_name)"
                  ></i>
                </button>
                <!-- <mat-slide-toggle [checked]="obj.isactive" *ngIf="isEdit" class="my-slider"
                      (change)="updateClientStatus($event,obj.customer_id)">
                    </mat-slide-toggle> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="JourneyObj.length === 0" style="text-align: center">
        <p>No Result Available</p>
      </div>
    </div>
  </div>
  <div class="mt-2 text-center difPagination" *ngIf="totalCount > 10">
    <ngb-pagination
      [collectionSize]="totalCount"
      [(page)]="page"
      [maxSize]="2"
      [rotate]="true"
      (pageChange)="getCompanyData((page = $event))"
      aria-label="Custom pagination"
    >
      <ng-template ngbPaginationPrevious>Prev</ng-template>
      <ng-template ngbPaginationNext>Next</ng-template>
    </ngb-pagination>
  </div>
</div>
